<template>
  <div
    id="chatbox"
    ref="chatbox"
    v-resize="onResizeChatbox"
    :style="{ height: chatboxHeight, 'overflow-y': isMobile ? 'hidden' : 'auto' }"
    @scroll="onMessageScroll"
  >
    <!-- <div v-html="debug" style="position:absolute; color:red;z-index: 10;background: white"></div> -->
    <template v-if="selectedUser">
      <v-toolbar
        dark
        color="primary"
        flat
        :absolute="!isMobile"
        :fixed="isMobile"
        style="top: 0; background: #ff9d85"
        :style="{ top: isMobile ? '56px' : '0px' }"
      >
        <v-btn
          v-show="isMobile"
          flat
          dark
          fab
          small
          class="ma-0 btn-back extra-small"
          @click="$emit('onClose')"
        >
          <v-icon medium>keyboard_arrow_left</v-icon>
        </v-btn>

        <v-toolbar-title
          v-if="['cityfresh'].includes($store.state.livechat.theme)"
          class="white--text text-truncate"
          >{{ selectedUser.first_name }} {{ selectedUser.last_name
          }}{{ `${selectedUser.realname ? ` (${selectedUser.realname})` : ''}` }}</v-toolbar-title
        >
        <!-- <v-toolbar-title v-else class="white--text text-truncate"
          >{{ selectedUser.first_name }} {{ selectedUser.last_name }}</v-toolbar-title
        > -->
        <template v-else>
          <template v-if="selectedUser.realname">
            <v-toolbar-title
              v-tooltip.right="`${selectedUser.first_name} ${selectedUser.last_name}`"
              class="white--text text-truncate"
              ><span
                style="
                  display: flex;
                  align-content: center;
                  align-items: center;
                  flex-direction: row;
                "
                >{{ selectedUser.realname }} <v-icon class="ml-2" small> info</v-icon></span
              >
            </v-toolbar-title>
          </template>
          <template v-else>
            <v-toolbar-title class="white--text text-truncate">
              {{ selectedUser.first_name }} {{ selectedUser.last_name }}
              <div v-if="isPrudential && selectedUser.app === 'webchat'" class="caption mt-1">
                <v-icon
                  :class="selectedUser.is_user_online ? 'success--text' : 'error--text'"
                  :style="{ verticalAlign: 'middle', fontSize: 'inherit' }"
                  >circle</v-icon
                >
                <span>{{ selectedUser.is_user_online ? $t('online_now') : $t('offline') }}</span>
              </div>
            </v-toolbar-title>
          </template>
        </template>

        <span v-if="selectedBot.type === 'summithr'" class="ml-2">
          {{ selectedUser.member_status ? selectedUser.member_status : '' }}</span
        >

        <v-spacer></v-spacer>
        <v-btn
          v-show="isMobile"
          flat
          dark
          fab
          small
          class="ma-0 btn-back"
          @click="$emit('onShowTool')"
        >
          <v-icon medium>settings_applications</v-icon>
        </v-btn>
        <div
          v-show="!isMobile"
          v-if="['102052945584054', '106855151601601'].includes(selectedBot.pageid)"
          style="white-space: nowrap"
        >
          <template
            v-if="
              ($store.state.nestlePages.some(
                (page) => page.pageid == $store.state.livechat.pageid
              ) &&
                $store.state.userid == 'zwizadmin') ||
              !$store.state.nestlePages.some((page) => page.pageid == $store.state.livechat.pageid)
            "
          >
            <v-btn
              v-if="
                selectedUser &&
                selectedUser.context &&
                selectedUser.context.startsWith('contactadmin') &&
                selectedBot.pageid != '102052945584054' &&
                selectedBot.pageid != '106855151601601'
              "
              color="white"
              small
              outline
              class="ma-1"
              style="line-height: 0"
              @click="endSession"
              >{{ $t('Switch to bot') }}</v-btn
            >
            <v-btn
              v-else-if="
                selectedUser &&
                selectedUser.context &&
                !selectedUser.context.startsWith('contactadmin')
              "
              color="white"
              small
              outline
              class="ma-1"
              style="line-height: 0"
              @click="openSession"
              >{{ $t('Switch to admin') }}</v-btn
            >
          </template>
          <cooldown :delay="10" cname="refresh_chat_user" @onLoad="onRefresh">
            <template #default="{ zloading, onClick, show }">
              <v-btn v-if="show" icon :loading="zloading" class="ma-1" @click="onClick">
                <v-icon>refresh</v-icon>
              </v-btn>
            </template>
            <template #countdown="{ show, delaytime, onCountdownEnd }">
              <template v-if="show && delaytime !== true && delaytime > 0">
                <v-btn v-if="show" icon :loading="true" class="ma-1">
                  <v-icon>refresh</v-icon>
                  <countdown :time="delaytime * 1000" @end="onCountdownEnd"> </countdown>
                </v-btn>
              </template>
            </template>
          </cooldown>
        </div>
        <div v-show="!isMobile" v-else style="white-space: nowrap">
          <template v-if="$store.state.toaPaintPage.includes(selectedBot.pageid)">
            <v-btn
              color="white"
              small
              outline
              style="line-height: 0"
              :loading="loadingExport"
              class="ma-1"
              @click="exportChatlog"
            >
              {{ $t('Export Chatlog') }}
            </v-btn>
          </template>
          <template v-if="showButtonSwitchToBot">
            <v-btn
              v-if="
                selectedUser.context == 'contactadmin' &&
                selectedBot.pageid != '102052945584054' &&
                selectedBot.pageid != '106855151601601'
              "
              color="white"
              small
              outline
              style="line-height: 0"
              class="ma-1"
              @click="endSession"
              >{{ $t('Switch to bot') }}</v-btn
            >
            <v-btn
              v-else-if="selectedUser.context != 'contactadmin'"
              color="white"
              small
              outline
              style="line-height: 0"
              @click="openSession"
              >{{ $t('Switch to admin') }}</v-btn
            >
          </template>
          <template v-if="selectedBot && selectedBot.type == 'gpf'">
            <v-btn
              v-tooltip.bottom="'Export Chatlog'"
              icon
              small
              :loading="loadingExport"
              @click="exportChatlog"
            >
              <v-icon>download</v-icon>
            </v-btn>
          </template>
          <cooldown :delay="10" cname="refresh_chat_user" @onLoad="onRefresh">
            <template #default="{ zloading, onClick, show }">
              <v-btn v-if="show" icon :loading="zloading" class="ma-1" @click="onClick">
                <v-icon>refresh</v-icon>
              </v-btn>
            </template>
            <template #countdown="{ show, delaytime, onCountdownEnd }">
              <template v-if="show && delaytime !== true && delaytime > 0">
                <v-btn v-if="show" icon :loading="true" class="ma-1">
                  <v-icon>refresh</v-icon>
                  <countdown :time="delaytime * 1000" @end="onCountdownEnd"> </countdown>
                </v-btn>
              </template>
            </template>
          </cooldown>
        </div>
      </v-toolbar>
      <div
        id="chatbox-container"
        style="position: relative"
        :style="{
          'padding-bottom': chatinputHeight + 'px',
          'margin-top': isMobile ? '56px' : '0px',
          top: isMobile ? '0px' : '64px'
        }"
      >
        <template v-if="messages.length > 0 && !isGetChatlogTimeout">
          <div id="messages">
            <template v-if="isMobile">
              <div
                class="text-xs-center"
                style="background: #eee; padding-top: 10px; padding-bottom: 10px; cursor: pointer"
                @click="onLoadmore"
              >
                <template v-if="loadmore">
                  <v-progress-circular
                    indeterminate
                    color="grey"
                    small
                    class="mr-2"
                    :width="2"
                  ></v-progress-circular
                  >Loading
                </template>
                <template v-else @click="onLoadmore">Click to load more conversation</template>
              </div>
            </template>
            <template v-else>
              <div
                v-if="loadmore"
                class="text-xs-center"
                style="background: #eee; padding-top: 10px; padding-bottom: 10px"
              >
                <v-progress-circular
                  indeterminate
                  color="grey"
                  small
                  class="mr-2"
                  :width="2"
                ></v-progress-circular
                >Loading
              </div>
            </template>
            <template v-for="(message, index) in messagesCheckmessageinDay">
              <div v-if="message.showDate" :key="index" style="width: 100%">
                <v-divider style="border-color: #ee6e73"></v-divider>
                <div
                  class="text-center"
                  style="margin-top: -12px; display: flex; justify-content: center; width: 100%"
                >
                  <span style="background-color: white; color: #ee6e73">{{
                    shotDate(message.timestamp)
                  }}</span>
                </div>
              </div>

              <message-item
                v-if="messages"
                :id="`message_${message.id}`"
                :key="'message-' + message.id + message.userid + message.pageid"
                v-model="messages[index]"
                :receiver="selectedUser"
                :message-id="message.message_id"
                :data="message"
              ></message-item>
            </template>
          </div>
        </template>
        <template v-else>
          <v-layout column justify-center fill-height>
            <div class="text-xs-center mt-5" style="color: #eee">
              <img src="/static/img/assets/livechat/no_message.png" alt />
              <p>
                {{
                  isGetChatlogTimeout
                    ? `Session timeout. ${$t('Please refresh the page and try again.')}`
                    : 'No message'
                }}
              </p>
            </div>
          </v-layout>
        </template>
      </div>

      <chat-input
        id="chatinput"
        v-model="selectedUser"
        :app="selectedUser.app"
        :new-message="chatnotify"
        :has-new-message="hasNewMessage"
        :refresh-chat-input="refreshChatInput"
        @loadmessage="getLastedMessages"
        @onSendMessage="onSendMessage($event)"
        @sendMessageDone="handleAfterSendMessage"
      >
        <template slot="header">
          <div class="text-xs-center">
            <template v-if="!isAutoRefresh">
              <v-btn small round color="primary" depressed @click="gotobottom">
                <v-icon class>arrow_drop_down</v-icon>Go to bottom
              </v-btn>
            </template>

            <template v-if="selectedUser.app == 'line' && showLine30Sec">
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-chip
                    style="vertical-align: middle"
                    small
                    round
                    color="primary"
                    depressed
                    class="white--text pl-0"
                    v-on="on"
                  >
                    <v-icon class="mr-2">schedule</v-icon>
                    <countdown :time="expectLine30Time * 1000" @end="onCountdownEnd">
                      <template slot-scope="props">
                        <template v-if="props.minutes">
                          {{ props.minutes }}
                          <span class="small">{{ $t('Minutes') + ' ' }}</span> </template
                        >{{ props.seconds }}
                        <span class="small">{{ $t('Seconds') }}</span>
                      </template>
                    </countdown>
                  </v-chip>
                </template>
                <span>{{
                  $t(
                    "Sending Messages in All-In-One Chat after 15 minutes of customer's response will count as a broadcast message on LINE OA"
                  )
                }}</span>
              </v-tooltip>
            </template>
          </div>
        </template>
      </chat-input>
    </template>
    <template v-else>
      <v-layout column justify-center fill-height>
        <div class="text-xs-center" style="color: #eee">
          <img src="/static/img/assets/livechat/no_user.png" alt />
          <p>Select a user</p>
        </div>
      </v-layout>
    </template>

    <v-snackbar v-model="showSnackbar" bottom right :timeout="3000" :color="'error'">
      Connection fail. Please try again
      <v-btn color="pink" flat fab dark small @click="showSnackbar = false">
        <v-icon small color="white">close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import messageItem from './livechat-message'
import moment from 'moment'
import chatInput from './livechat-chatinput'
import api from '@/api'
import Cooldown from '@/components/elements/Cooldown'
import XLSX from 'xlsx'

import allInOneChatApi from '@/api/all-in-one-chat'
import { getPage } from '@/config/customize'

import { handleResponse, handleApiError } from '@/api/util'
import { PAGE } from '@/constants/page'

export default {
  components: {
    'message-item': messageItem,
    'chat-input': chatInput,
    Cooldown
  },
  props: ['value', 'isMobile', 'newchatnotify'],
  data: function () {
    return {
      loadmore: false,
      showSnackbar: false,

      chatboxHeight: 0,
      loading: false,
      maxTime: 10000,
      timer: '',
      isAutoRefresh: true,
      currentIndex: null,
      offset: 0,
      limit: 100,
      messages: [],
      // oldMessages: [],
      endChatlog: false,
      windowHeight: 0,
      newMessage: null,
      chatinputHeight: 0,
      debug: '',
      hasNewMessage: false,
      refreshChatInput: null,
      hippopage: ['100825145655476', '103267601317473', '208321456497173', '113700147637887'],

      showLine30Sec: false,
      expectLine30Time: null,
      latestMessageId: null,
      maxLineTokenExpired: 1200,
      loadingExport: false,
      isGetChatlogTimeout: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      selectedUser: 'getCurrentUser'
    }),
    showButtonSwitchToBot() {
      if (getPage(this.$store.state.livechat.pageid) === 'truecorp') {
        return false
      } else {
        return (
          (this.$store.state.nestlePages.some(
            (page) => page.pageid == this.$store.state.livechat.pageid
          ) &&
            this.$store.state.userid == 'zwizadmin') ||
          !this.$store.state.nestlePages.some(
            (page) => page.pageid == this.$store.state.livechat.pageid
          )
        )
      }
    },
    messagesCheckmessageinDay() {
      if (this.messages) {
        let output = []
        let messages = this.messages
        let cash_date = null
        messages.forEach((message) => {
          if (message.timestamp) {
            let date = moment(new Date(message.timestamp)).format('YYYY-MM-DD')
            if (cash_date && date == cash_date) {
              output.push({ ...message, showDate: false })
            } else {
              cash_date = date
              output.push({ ...message, showDate: true })
            }
          }
        })
        return output
      } else {
        return []
      }
    },
    chatnotify() {
      if (this.$store.state.livechat.app == 'facebook')
        return {
          admin: this.newchatnotify.facebook_admin,
          bot: this.newchatnotify.facebook_bot
        }
      else if (this.$store.state.livechat.app == 'line')
        return {
          admin: this.newchatnotify.line_admin,
          bot: this.newchatnotify.line_bot
        }
      else {
        return {
          admin: 0,
          bot: 0
        }
      }
    },
    isPrudential() {
      return PAGE.PRUDENTIAL.includes(this.selectedBot.pageid)
    }
  },
  watch: {
    selectedUser: function (newVal, oldVal) {
      // this.selectedUser = newVal
      if (newVal == null || oldVal == null || oldVal != newVal) {
        this.resetChatlog()
        this.getLastedMessages()
      }
    },
    selectedBot: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.selectedUser = null
        this.resetChatlog()
      }
    }
  },
  created: async function () {
    let vm = this
    this.resetChatlog()
    await this.getLastedMessages()
    await this.wait(1000)
    if (vm.isMobile) {
      document.body.onscroll = function () {
        vm.onMessageScroll()
      }
    }
  },
  mounted: function () {
    if (!this.timer) this.timer = setInterval(this.getLastedMessages, this.maxTime)
  },
  async updated() {
    this.snapBottom()
  },
  beforeDestroy: function () {
    //console.log('clear')
    clearInterval(this.timer)
    document.removeEventListener('scroll', null, false)
  },
  methods: {
    onCountdownEnd() {
      this.showLine30Sec = false
      this.expectLine30Time = null
    },
    shotDate: function (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    onResizeChatbox: function () {
      var vm = this
      vm.$nextTick(function () {
        if (this.isMobile) {
          vm.chatboxHeight = 'auto'
          // vm.chatinputHeight = 0
        } else {
          vm.chatboxHeight =
            window.innerHeight - document.getElementById('main_toolbar').clientHeight - 5 + 'px'
        }
        if (document.getElementById('chatinput')) {
          vm.chatinputHeight = document.getElementById('chatinput').clientHeight
        }
        vm.debug =
          `Chatbox Height: ${vm.chatboxHeight}<br>` +
          `Input Height: ${vm.chatinputHeight}<br>` +
          `Screen Height: ${screen.height}<br>` +
          `Main Toolbar: ${document.getElementById('main_toolbar').clientHeight}<br>` +
          `Window: ${window.innerHeight}<br>`
      })
    },
    async onSendMessage(payload) {
      this.onCountdownEnd()
      this.messages.push(payload)
      await this.snapBottom()
      // console.log(payload)
    },
    async handleAfterSendMessage() {
      this.getLastedMessages()
    },
    getLastedMessages: async function () {
      var vm = this
      let limit = 15

      if (vm.messages.length == 0) {
        limit = 15
      }
      if (!vm.selectedUser) {
        return false
      }
      try {
        await vm.getUserMessages(0, limit, true)
        vm.onResizeChatbox()
        if (vm.isAutoRefresh && document.getElementById('messages')) {
          // $('#chatbox').animate({ scrollTop: document.getElementById('messages').clientHeight })
          await vm.snapBottom()
        }
      } catch (error) {
        console.error(error)
      }
      //console.log('loaded', this.selectedUser.userid)
    },
    getUserMessages: function (offset, limit, latest) {
      let vm = this
      return new Promise((resolve, reject) => {
        if (vm.selectedBot == null || vm.selectedUser == null || vm.loading || !vm.isAutoRefresh) {
          reject()
          // return false
        }
        vm.loading = true
        let data = {
          pageid: vm.$store.state.livechat.pageid,
          userid: vm.selectedUser.userid,
          offset: offset,
          limit: limit,
          adminid: vm.$store.state.userid
        }
        if (!latest) {
          vm.loadmore = true
        }

        try {
          vm.isGetChatlogTimeout = false
          allInOneChatApi.getChatLog({ data }).then((response) => {
            handleResponse(response).then(() => {
              const { data } = response.data
              if (data) {
                let messages = data
                try {
                  messages = messages.map((el) => {
                    if (el.messagetype == 'json') {
                      let json = []
                      try {
                        json = JSON.parse(el.messagedata)
                      } catch (error) {
                        // console.log(`el.messagedata: `, el.messagedata)
                        console.error(error)
                      }
                      let bubbles = json.filter((b) => {
                        if (b.type == 'text' && b.text == '') {
                          return false
                        }
                        return true
                      })

                      return {
                        ...el,
                        messagedata: JSON.stringify(bubbles)
                      }
                    }
                    return el
                  })
                } catch (error) {
                  console.error(error)
                }

                if (!latest && messages.length == 0) {
                  vm.endChatlog = true
                }
                if (latest) {
                  if (
                    messages &&
                    messages[0] &&
                    this.messages &&
                    this.messages[this.messages.length - 1]
                  ) {
                    if (
                      this.messages[this.messages.length - 1].id &&
                      messages[0].id &&
                      this.messages[this.messages.length - 1].total &&
                      messages[0].total &&
                      parseInt(this.messages[this.messages.length - 1].id) <
                        parseInt(messages[0].id)
                    ) {
                      //
                    } else {
                      return
                    }
                  }
                  if (vm.messages.length == 0) {
                    let reverse_messages = messages.reverse()
                    vm.messages = []
                    reverse_messages.map(function (el) {
                      vm.messages.push(el)
                    })
                    vm.$nextTick(function () {
                      if (vm.isAutoRefresh) {
                        vm.snapBottom()
                      }
                    })
                  } else {
                    if (
                      messages &&
                      messages[0] &&
                      vm.currentIndex &&
                      messages[0].id == vm.currentIndex.id
                    ) {
                      // console.log('Noting Change')
                      vm.loading = false
                      resolve()
                    } else {
                      vm.messages = vm.messages.splice(0, vm.currentIndex.index)
                      let tmpIndex = messages.findIndex((val) => {
                        return val.id == vm.currentIndex.id
                      })

                      if (tmpIndex != -1) {
                        for (var i = tmpIndex; i >= 0; i--) {
                          vm.messages.push(messages[i])
                        }

                        if (messages[0]) {
                          vm.newMessage = messages[0]
                        }

                        vm.snapBottom()
                      }
                      resolve()
                    }
                  }
                  vm.$nextTick(() => {
                    // หาข้อความที่ส่งไม่เกิน 15 นาที
                    if (messages && messages.length > 0) {
                      let latest_message = [...messages].sort(
                        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
                      )[0]
                      if (vm.latestMessageId == null || vm.latestMessageId != latest_message.id) {
                        vm.latestMessageId = latest_message.id
                        let sec = moment().diff(moment(latest_message.timestamp), 'second', true)

                        if (
                          sec <= vm.maxLineTokenExpired &&
                          (latest_message.answerby == null ||
                            latest_message.answerby == '' ||
                            (latest_message.answerby == 'bot' &&
                              latest_message.messagetype == 'noreply'))
                        ) {
                          vm.expectLine30Time = vm.maxLineTokenExpired - sec
                          vm.showLine30Sec = true
                        }
                      }
                    }
                  })
                } else {
                  vm.messages = messages.reverse()
                  vm.loadmore = false
                }
                if (vm.messages.length > 0) {
                  vm.currentIndex = {
                    id: vm.messages[vm.messages.length - 1].id,
                    index: vm.messages.length - 1
                  }
                }
                vm.loading = false
              }
              resolve()
            })
          })
        } catch (error) {
          handleApiError(error).then(() => {
            if (error.code == 'ECONNABORTED') {
              vm.isGetChatlogTimeout = true
            }

            if (error) {
              if (!latest) {
                vm.loadmore = false
              }

              vm.showSnackbar = true

              reject(error)
            }
          })
        }
      })
    },
    onMessageScroll: function () {
      let scrollPosition = 0
      if (this.isMobile) {
        scrollPosition = window.pageYOffset + window.innerHeight
        let totalHeight = document.body.scrollHeight
        // console.log(totalHeight == scrollPosition)
        if (totalHeight == scrollPosition) {
          this.isAutoRefresh = true
        } else {
          this.isAutoRefresh = false
        }
        // console.log(scrollPosition, totalHeight)
        return false
      } else {
        let messages = document.getElementById('chatbox')
        scrollPosition = messages.scrollTop
        let chatboxHeight = messages.clientHeight
        let totalHeight = messages.scrollHeight
        // console.log(scrollPosition, chatboxHeight, totalHeight)
        if (totalHeight - 30 <= scrollPosition + chatboxHeight) {
          this.isAutoRefresh = true
        } else {
          this.isAutoRefresh = false
        }
      }

      if (scrollPosition == 0) {
        this.onLoadmore().then(function () {})
      }
    },
    onLoadmore: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        if (vm.loadmore) {
          reject()
        }
        vm.limit += 100
        vm.getUserMessages(vm.offset, vm.limit, false).then(
          function () {
            // $('#chatbox').animate({ scrollTop: 0 })
            resolve()
          },
          function () {}
        )
      })
    },
    async snapBottom() {
      let vm = this
      if (!vm.isAutoRefresh || vm.loadmore) {
        return false
      }
      await vm.gotobottom()
    },
    async gotobottom() {
      await this.$nextTick()
      let messages = $('#messages')
      if (messages.length > 0) {
        if (this.isMobile) {
          window.scrollTo(
            0,
            document.body.scrollHeight +
              (this.chatinputHeight == 0 ? 114 : this.chatinputHeight * 2)
          )
        } else {
          document
            .getElementById('chatbox')
            .scrollTo(0, document.getElementById('messages').clientHeight)
        }
      }
    },
    resetChatlog: function () {
      this.messages = []
      this.offset = 0
      this.limit = 100
      this.endChatlog = false
      this.loading = false
      this.loadmore = false
      this.isAutoRefresh = true
      this.newMessage = null
    },
    endSession: function () {
      this.$emit('endSession')
    },
    openSession: function () {
      this.$emit('openSession')
    },
    onRefresh: function (payload) {
      var vm = this
      vm.resetChatlog()
      vm.getLastedMessages()

      if (this.hippopage.includes(this.$store.state.livechat.pageid)) {
        vm.GetHoldChat()
      }
      if (payload) payload.callback()
    },
    async GetHoldChat() {
      // Check hold
      let payload = {
        pageId: this.$store.state.livechat.pageid,
        userId: this.$store.state.livechat.currentUser.userid,
        adminid: this.$store.state.userid
      }
      let result = await api.GetHippoHoldChat(payload)
      this.refreshChatInput = result
    },
    exportChatlog() {
      const vm = this
      let limit = 500
      let offset = 0

      if (vm.selectedBot == null || vm.selectedUser == null) {
        return false
      }

      vm.loadingExport = true
      let data = {
        pageid: vm.$store.state.livechat.pageid,
        userid: vm.selectedUser.userid,
        offset: offset,
        limit: limit,
        adminid: vm.$store.state.userid
      }

      allInOneChatApi.getChatLog({ data }).then((response) => {
        handleResponse(response).then(() => {
          const { data } = response.data
          try {
            if (data) {
              let chatlog = data
              let filename = `Chatlog-${chatlog[0].first_name}`
              let json = []
              let i = 0
              chatlog.forEach((val) => {
                if (
                  vm.selectedBot &&
                  (vm.selectedBot.type == 'gpf' ||
                    [...vm.$store.state.toaPaintPage].includes(vm.selectedBot.pageid)) &&
                  val['questiondata']
                ) {
                  i++
                  let Questions = val['questiondata'] ? val['questiondata'] : 'NULL'
                  if (Questions !== 'NULL' && Questions.toString().startsWith('data:image/')) {
                    Questions = `{image}`
                  }

                  json.push({
                    SEQ: i,
                    Date: moment(val['timestamp']).format('DD/MM/YYYY HH:mm:ss'),
                    Questions,
                    Intents: val['intent'] ? val['intent'] : 'NULL',
                    Answers: val['messagedata'] ? val['messagedata'] : 'NULL',
                    'Answer By': val['answerby'] ? val['answerby'] : 'NULL'
                  })
                }
              })

              const wb = XLSX.utils.book_new()
              const dataWS = XLSX.utils.json_to_sheet(json)
              XLSX.utils.book_append_sheet(wb, dataWS)
              XLSX.writeFile(wb, `${filename}.xlsx`)
              vm.loadingExport = false
            }
          } catch (error) {
            console.error(error)
            vm.loadingExport = false
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-back i {
  line-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chatbox.vue